import {
    Flex, Divider, Button, HStack, VStack
} from '@chakra-ui/react'
import React from 'react'
import { BsCardChecklist, BsFilePlus, BsViewList } from "react-icons/bs";
import { BlockContainer, BlockHeader } from '../components/shared/Block'
import { Link } from 'react-router-dom'
import TableUserForm from '../components/dashboard/TableUserForm';
import TableUserQueues from '../components/dashboard/TableUserQueues';

const DisplayBlock = () => {
    return (
        <VStack spacing={8}>
            <BlockContainer>
                <BlockHeader title="รายการแบบคำร้อง" icon={BsCardChecklist}>
                    <HStack spacing={2}>
                        <Link to="/formagree">
                            <Button leftIcon={<BsFilePlus />} colorScheme="green" size="sm" variant="outline">ยื่นแบบคำร้อง</Button>
                        </Link>
                    </HStack>
                </BlockHeader>
                <Divider />
                <Flex w="full" pt={5}>
                    <TableUserForm />
                </Flex>
            </BlockContainer>
            <BlockContainer>
                <BlockHeader title="ลำดับคิว" icon={BsViewList} />
                <Divider />
                <Flex w="full" pt={5}>
                    <TableUserQueues />
                </Flex>
            </BlockContainer>
        </VStack>
    )
}


const Dashboard = () => {
    return (
        <Flex p="40px" direction="column" w="full">
            <DisplayBlock />
        </Flex>
    )
}

export default Dashboard
